var skland = {
    isInContainer: false,
    onReturn: function () { },
};
try {
    require.resolve("@skland/one-bridge");
    var oneBridge = require("@skland/one-bridge");
    var bridge = oneBridge.default;
    skland = {
        isInContainer: bridge.getSystemInfo().isApp,
        onReturn: bridge.pop,
    };
}
catch (error) { }
export { skland };
